import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 30000 });

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    const isAuthPath = config?.url?.startsWith("/auth/");
    if (response?.status === 401 && !config._retried && !isAuthPath) {
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
        await refreshing;
        return api(config);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export function errorMessage(error, fallback = "Something went wrong. Please try again.") {
  if (!error) return fallback;
  if (error.code === "ERR_NETWORK") return "Network error. Please check your connection and try again.";
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  if (error.response?.status === 429) return "Too many requests. Please try again later.";
  if (error.response?.status >= 500) return "Server error. Please try again in a moment.";
  return error.message || fallback;
}

export const fileDownloadUrl = (publicId) => `${API_BASE}/files/${publicId}/download`;
export const filePreviewUrl = (publicId) => `${API_BASE}/files/${publicId}/preview`;
